import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReportStore} from '../../../shared/store/report/report.store';
import {ReportPathExplorerStore} from '../../../shared/store/report/report-path-explorer.store';
import {Observable} from 'rxjs';
import {AdRequestParams} from '../../../shared/interfaces/ad-reports';
import {ReportParamsStore} from '../../../shared/store/report/report-params.store';
import {PublicReportData} from '../../../shared/store/publicReports/public-reports';

@Component({
  selector: 'app-path-explorer-report',
  templateUrl: './path-explorer-report.component.html',
  styleUrls: ['./path-explorer-report.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportPathExplorerStore
  ]
})
export class PathExplorerReportComponent implements OnInit, OnDestroy {
  public readonly loading$: Observable<boolean> = this._reportPathExplorerStore.loading$;
  public readonly data$: Observable<Array<any>> = this._reportPathExplorerStore.data$;
  public readonly totals$: Observable<any> = this._reportPathExplorerStore.totals$;
  public readonly requestParams$: Observable<Partial<AdRequestParams>> = this._reportStore.requestParams$;

  @Input('publicReportData') set setReport(publicReportData: PublicReportData | null | undefined) {
    if (publicReportData) {
      this._reportStore.initPublicReport(
        publicReportData.report,
        publicReportData.uuid,
        publicReportData.token
      );
    }
  };

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _reportPathExplorerStore: ReportPathExplorerStore
  ) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

}
